import './Text.css';
import React, { useState } from 'react';


export function FreedomSchool() {
  const [UAdOclTYQ80] = useState('UAdOclTYQ80')
  return (
    <div class="body">
            <div class="row" >




<iframe  allow="fullscreen *"
frameborder="0"
        title='Freedom School'
        
        src={`https://youtube.com/embed/${UAdOclTYQ80}?autoplay=0`}>
</iframe>




      
      </div>
      
            <div class="row" id="GalleryThree">
              
  <div class="column" id="centered">   
                    <h2> Freedom School </h2>
                    <h4> Detroit, MI 2026
                        <br/><br/>
"Two-week intensive training program coordinated by scholars and civil rights activists
 who worked directly with the Boggs. Based in Detroit, it will combine study 
 sessions, community dialogs, tours, and practical experience in the field. 
 Community-based teachers, artists, and architects, and organizers will lead 
 workshops on issues like urban farming and food sovereignty, place-based education, 
 adical art and design, civil rights and multiracial solidarity." 
<br/><br/>
 – <a>boggsfoundation.org</a>


</h4>
</div>

             <div class="column"id="centered">  

<img src="FreedomSchool04.jpg" width="400px"></img>

<h4>Hand-drawn, screenprinted design with Talking Dolls studio.</h4>

           


                </div>

             <div class="column" id="centered">
<br/>
Involved Prganizations and People:
<hr/>

The James and Grace Lee Boggs School<br/>
Wayne State University Libraries<br/>
Eastside Community Network<br/>
Shrine of the Black Madonna<br/>
Brother Nature Produce<br/>
Black Convergence<br/>
The LOVE Building<br/>
Fennigan's Farms<br/>
Joe Rilley Music<br/>
Pink Flamingo<br/>
Rising Voices<br/>
Talking Dolls<br/>
BasBlue.<br/>
</div>


</div>

            <div class="row" id="GalleryFour"></div>

</div>


  );
}
